export default __webpack_public_path__ + "static/media/pc-screen-solar-panels-manufacturing-plant-used-study-solar-energy-systems.eee711a3.webp";